// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"8edccaf1","560":"90eb2f2d","673":"27ef0c69","914":"22bc2013","941":"49fd8bc7"}[chunkId] + ".chunk.css";
};